const messages = {
  BLOCKED_USER:
    'Parece que você tentou logar várias vezes e foi temporariamente bloqueado.',
  WRONG_PASSWORD: 'Ops... Senha incorreta, tente novamente.',
  DEFAULT: 'Ops...Encontramos um problema por aqui. Tente novamente.'
}

export { messages }
